import styled from 'styled-components'

const SwitchStyled = styled.div``
export default SwitchStyled
